import { NJInlineMessage } from '@engie-group/fluid-design-system-react';

const LegalMessage = () => {


    return (
        <NJInlineMessage variant="warning">
            <span data-child-name="njInlineMessageTitle">
                ENGIE Job Generator may make mistakes. 
                Please check carefully the information contained in the optimized ad.
            </span>
        </NJInlineMessage>
    )
}

export default LegalMessage;